import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
//import { ToastrService } from 'ngx-toastr';
import { CallModel } from 'src/app/shared/models/calllog.model';
import { IssueFileModel, IssueModel, IssueTrackDetailModel, IssueTrackModel } from 'src/app/shared/models/issue.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { IssueTrackService } from 'src/app/shared/services/issue-track.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-issue-track',
  templateUrl: './issue-track.component.html',
  styleUrls: ['./issue-track.component.css']
})
export class IssueTrackComponent implements OnInit {
   @Input() call : CallModel;
   @Input() issue : IssueModel;
   @Input() users : UserModel [];
   //thisData : IssueTrackModel [];
   thisData : IssueTrackDetailModel [];

    form: FormGroup = IssueTrackModel.getFormGroup();
    files : IssueFileModel [];
    modalImage : string;
  constructor(private service : IssueTrackService,
    //private toastr : ToastrService
    private gnotify : GlobalNotification
    ) { }

  ngOnInit() {

    IssueTrackModel.initializeFormGroup(this.form, this.issue.issueId)
    this.refreshList();
  }

  refreshList()
  {
    if(this.issue == null) return;

    this.service.findDataByIssue(this.issue.issueId).subscribe(
      res => {
        //this.thisData = res as IssueTrackModel [];
        this.thisData = res as IssueTrackDetailModel [];

        let result = this.thisData.map(
          obj => {
            obj.createByUser = this.users.find(item => item.id === obj.createBy);
            if(obj.fileString != null) obj.files = obj.fileString.split(',');
            return {...obj}
          }
        );
        console.log("refreshList");

       },
       err =>{
         console.log(err);
       }
    );

  }

  onSave()
  {

    console.log("onSave : " + this.form.get('issueId').value);
    //this.form.setValue({issueId: this.issue.issueId});

    if(!this.form.get('solution').value){
      ////this.toastr.error("Please type the solution and try again.", "Invalid");
      this.gnotify.showSnackBar('Invalid', 'Please type the solution and try again.', "error");
      return;
    }


    if (this.files)
    {
        this.form.value.files = new Array<string>();
        for(var item of this.files)
        {
          this.form.value.files.push(item.fileId);
        }
    }

    if(!this.form.get('trackId').value)
    {

      this.service.insertData(this.form.value).subscribe(
        res=>{
          ////this.toastr.success("Submit successfuly", "Issue Create");
          this.gnotify.showSnackBar('Issue Create', 'Submit successfuly', "success");
          if(this.call)
          {
            this.call.issueTrack = res as IssueTrackModel;
          }
          this.refreshList();
          IssueTrackModel.initializeFormGroup(this.form, this.issue.issueId);
          this.files = null;
        },
        err=>{
          console.log(err);
          ////this.toastr.error("Failed to Submit", "Issue Create");
          this.gnotify.showSnackBar('Issue Create', 'Failed to Submit', "error");
        }
        );

        if(this.call) // this code should be called after service function ( this will delete files value from the form data)
        {
          this.form.controls['callId'].setValue(this.call.callLog.callId);
        }

    }

  }

  onDelete(id)
  {
    if(!confirm("Are you sure to delete this solution?")) return;

    this.service.deleteData(id).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "FaQ Delete");
        this.gnotify.showSnackBar('Issue Delete', 'Submitted successfully', "warning");
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

  onDeleteFile(fileId)
  {
      if(!confirm("Are you sure to delete this image?")) return;
      this.files = this.files.filter(item => item.fileId != fileId);
  }

  public uploadFinished = (event) => {

    if(event)
    {
      if(!this.files) this.files = new Array<IssueFileModel>();
       this.files.push( IssueFileModel.convertFromUploadedFile(event));
    }

  }

  openModal(imagelink) {

    this.modalImage = imagelink;

    console.log(this.modalImage);
    document.getElementById('imgModal').style.display = "block";

  }

  closeModal() {
    document.getElementById('imgModal').style.display = "none";
  }

}
